import { render, staticRenderFns } from "./log-virtual.vue?vue&type=template&id=66727f12&scoped=true"
import script from "./log-virtual.vue?vue&type=script&lang=js"
export * from "./log-virtual.vue?vue&type=script&lang=js"
import style0 from "./log-virtual.vue?vue&type=style&index=0&id=66727f12&prod&scoped=true&lang=scss"
import style1 from "./log-virtual.vue?vue&type=style&index=1&id=66727f12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66727f12",
  null
  
)

export default component.exports